import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import Badge from "../../Badge";
import { ITab } from "../types";
import { StyledTab, TextWrapper } from "./styled";

const Tab: React.FC<ITab> = ({
    title,
    path,
    disabled = false,
    removeSearch,
    badge,
    badgeVariant = "tertiary",
    matchExact = false,
    hide = false
}) => {
    const location = useLocation();

    if (hide) return null;

    const isActive: boolean = !!matchPath(location.pathname, { path, exact: matchExact || path === "/" });

    return (
        <StyledTab
            key={path}
            $isActive={isActive}
            $isDisabled={disabled}
            onClick={e => {
                disabled && e.preventDefault();
            }}
            to={{ pathname: path, search: removeSearch ? "" : location.search }}
        >
            <TextWrapper $isActive={isActive}>
                {title}
                {!!badge && <Badge text={badge} variant={badgeVariant} />}
            </TextWrapper>
        </StyledTab>
    );
};

export default Tab;
